import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=8935c3d2&"
import script from "./ConfirmationPage.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports